import { useToastState } from '../context/ToastContext';

const ICONS: Record<string, string> = {
  success: '✓',
  error:   '✕',
  info:    'ℹ',
};

const STYLES: Record<string, string> = {
  success: 'bg-emerald-600 text-white',
  error:   'bg-red-600 text-white',
  info:    'bg-primary-600 text-white',
};

export function Toaster() {
  const { toasts, dismiss } = useToastState();

  if (toasts.length === 0) return null;

  return (
    <div
      aria-live="polite"
      aria-label="Notifications"
      className="fixed top-4 right-4 z-[100] flex flex-col gap-2 sm:right-6"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          role="alert"
          className={`
            flex items-center gap-3 rounded-xl px-4 py-3 shadow-lg
            text-sm font-medium min-w-[220px] max-w-[360px]
            animate-[slideUp_0.2s_ease-out]
            ${STYLES[t.type]}
          `}
        >
          <span className="flex-shrink-0 rounded-full bg-white/20 p-0.5 text-xs leading-none w-5 h-5 flex items-center justify-center font-bold">
            {ICONS[t.type]}
          </span>
          <span className="flex-1 leading-snug">{t.message}</span>
          <button
            onClick={() => dismiss(t.id)}
            aria-label="Dismiss"
            className="flex-shrink-0 rounded p-0.5 opacity-70 hover:opacity-100 transition-opacity text-base leading-none"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
